// extracted by mini-css-extract-plugin
module.exports = {"slide":"_base-icon_slide_3DKOu","slide-reverse":"_base-icon_slide-reverse_2PjBB","fontAwesome":"_base-icon_fontAwesome_BOb2-"};